import { Button } from "@/components/ui/button";
import { PacotePromocionalDto } from "@/dtos/BuscarSorteioVigenteDto";
import { labelPlural } from "@/utils/copyTituloBilhete";

interface ConfirmacaoPacoteGiroProps {
    pacote: PacotePromocionalDto;
    ctaLabel: string;
    disabled?: boolean;
    disabledLabel?: string;
    ctaVariant?: "default" | "foreground";
    ctaClassName?: string;
    onContinuar: () => void;
    onAlterarSelecao: () => void;
}

export function ConfirmacaoPacoteGiro({
    pacote,
    ctaLabel,
    disabled = false,
    disabledLabel = "Venda indisponível",
    ctaVariant = "foreground",
    ctaClassName = "w-40",
    onContinuar,
    onAlterarSelecao,
}: ConfirmacaoPacoteGiroProps) {
    return (
        <div className="flex flex-col items-center justify-center gap-4">
            <h1 className="text-center text-primary font-semibold text-xl">
                Pacote selecionado
            </h1>
            <p className="text-center text-primary text-2xl font-semibold">
                {pacote.Qtd} {labelPlural()}
            </p>
            {pacote.Valor > 0 && (
                <p className="text-center text-primary text-lg">
                    {pacote.Valor.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                    })}
                </p>
            )}
            <Button
                type="button"
                variant={ctaVariant}
                className={ctaClassName}
                disabled={disabled}
                onClick={onContinuar}
            >
                {disabled ? disabledLabel : ctaLabel}
            </Button>
            <Button type="button" variant="outline" onClick={onAlterarSelecao}>
                Alterar seleção
            </Button>
        </div>
    );
}
